    <template >
  <div class="formPosition">
    <template>

      <!--  classes em aue se tem discplinas  -->
      <v-container

        v-if="!disciplinas.length"
        class="grey lighten-5"
      >
        <v-row no-gutters>
          <v-col>
            Lancar nota -
            <strong>Cadeirantes</strong>
            <br />

            <span v-if="listaDeClassesPorLancarNotas.length && !progresso">Escolhe uma classe para encontrar a turma</span>

            <v-icon v-if="!progresso" large color="green darken-2">forward</v-icon>
            <span v-if="!listaDeClassesPorLancarNotas.length && !progresso">Nenhuma turma para ser exibida.</span>
            <br />
            <span v-if="!listaDeClassesPorLancarNotas.length && !progresso">- Certifica-se de que tenha as permissôes correctas.</span>
            <br v-if="!listaDeClassesPorLancarNotas.length && !progresso" />
            <span
              v-if="!listaDeClassesPorLancarNotas.length && !progresso"
            >- Caso estejas logado com uma conta de Sub-director pedagógico ou de coordenador, provalvemente nao existam turmas criadas. Deverá cria-las e atribuir a no mínimo um professor.</span>
            <br v-if="!listaDeClassesPorLancarNotas.length && !progresso" />
            <span
              v-if="!listaDeClassesPorLancarNotas.length && !progresso"
            >- Caso estejas logado com uma conta de professor, pode não ter sido atrbuida turmas a sí. Contacte o Sub-director pedagógico. Obrigado</span>
            <br v-if="!listaDeClassesPorLancarNotas.length && !progresso" />

          <div class="text-center" v-if="progresso">

                <!--================PROGRESSO===========================-->
                  <span v-if="progresso">Procurando por turmas , por favor aguarde...</span>

                  <v-progress-circular
                          v-if="progresso"
                          indeterminate
                          color="green"
                  ></v-progress-circular>

              <!--===================/Progresso=====================-->

            </div>

            <div v-if="listaDeClassesPorLancarNotas.length && !progresso" class="text-center">
              <v-btn
                @click="classe(1)"
                v-if="listaDeClassesPorLancarNotas.filter(turma =>turma.idAno_Academico===1).length && !progresso"
                class="ma-2"
                outlined
                color="indigo"
              >
                <v-icon small color="primary">filter_1</v-icon>10ª classe
              </v-btn>
              <v-btn
                @click="classe(2)"
                v-if="listaDeClassesPorLancarNotas.filter(turma =>turma.idAno_Academico===2).length && !progresso"
                class="ma-2"
                outlined
                color="indigo"
              >
                <v-icon small color="primary">filter_2</v-icon>11ª classe
              </v-btn>
              <v-btn
                @click="classe(3)"
                v-if="listaDeClassesPorLancarNotas.filter(turma =>turma.idAno_Academico===3).length && !progresso"
                class="ma-2"
                outlined
                color="indigo"
              >
                <v-icon small color="primary">filter_3</v-icon>12ª classe
              </v-btn>
              <v-btn
                @click="classe(4)"
                v-if="listaDeClassesPorLancarNotas.filter(turma =>turma.idAno_Academico===4).length && !progresso"
                class="ma-2"
                outlined
                color="indigo"
              >
                <v-icon small color="primary">filter_4</v-icon>13ª classe
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>

      <!--  list turmas  -->
      <v-container>
        <v-row no-gutters>
          <v-col>
            <!-- v-if="!listEstudantfromPauta.length"   v-if="listaDeClassesPorLancarNotas.filter(turma =>turma.idAno_Academico===idanoacademico).length"   -->
            <template
              v-if="!disciplinas.length&&listaDeClassesPorLancarNotas.filter(turma =>turma.idAno_Academico===idanoacademico).length"
            >
              <v-container class="text-md-left">
                <v-row no-gutters>
                  <v-col>
                    <v-card class="d-flex flex-row mb-6" max-width="400" tile>
                      <v-list flat>
                        <v-subheader>você tem {{listaDeClassesPorLancarNotas.filter(turma =>turma.idAno_Academico===idanoacademico).length}} Turma(s) da {{_classe }}. clica em uma para prosseguir</v-subheader>
                        <v-list-item-group v-model="item" color="primary">
                          <v-list-item
                            v-for="(item, i) in listaDeClassesPorLancarNotas.filter(turma =>turma.idAno_Academico===idanoacademico)"
                            :key="i"
                          >
                            <v-list-item-icon>
                              <v-icon v-text="item.icon"></v-icon>
                            </v-list-item-icon>

                            <v-list-item-content color="primary" dark v-on="on">
                              <v-list-item-title
                                v-text="item.turma_descricao"
                                @click="ChamaListaInscritos(item)"
                              ></v-list-item-title>

                              <v-list-item-subtitle @click="ChamaListaInscritos(item)">
                                <strong>{{item.estudantes}}</strong>
                                estudantes na turma - Periodo {{item.periodo}}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </template>
          </v-col>

          <v-col></v-col>
        </v-row>
      </v-container>

      <!--  list disciplinas  -->
      <v-container v-if="disciplinas.length && !listaEstudantesInscritos.length">
        <v-row no-gutters>
          <v-col>
            <!-- v-if="!listEstudantfromPauta.length"   -->

            <template v-if="listaDeClassesPorLancarNotas.filter(turma =>turma.idAno_Academico===idanoacademico).length">
              <v-container class="text-md-left">
                <v-row no-gutters>
                  <v-col>
                    <v-card class="d-flex flex-row mb-6" max-width="400" tile>
                      <v-btn
                        @click="backToTurmaList"
                        class="mx-2"
                        fab
                        dark
                        color="primary"
                        v-on="on"
                      >
                        <v-icon dark>arrow_back</v-icon>
                      </v-btn>
                      <v-list flat>
                        <v-subheader>
                          você tem {{disciplinas.filter(disciplina=>disciplina.iddisciplina === 12).length}} disciplina(s) na {{this.$store.state.turma}} . Seleciona uma para prosseguir
                          <br />
                          <br />
                        </v-subheader>
                        <v-list-item-group v-model="item" color="primary">
                          <v-list>
                            <v-list-item v-for="(item, index) in disciplinas" :key="index">
                              <v-list-item-title
                                v-text="item.descricao"
                                @click="pautaByTurma(item)"
                              ></v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-list-item-group>
                      </v-list>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </template>
          </v-col>

          <v-col></v-col>
        </v-row>
      </v-container>
      <!--  fim discp  -->
    </template>

  <template v-if="listaEstudantesInscritos.length">

    <v-form ref="form" v-model="formValid" lazy-validation>
      <v-container class="text-md-left">
        <v-row no-gutters>
          <v-col>
            <v-card class="d-flex flex-row mb-6" tile>
              <v-list flat>
                <v-btn @click="backTodisciplinList" class="mx-2" fab dark color="primary" v-on="on">
                  <v-icon dark>arrow_back</v-icon>
                </v-btn>
                <v-header>
                   <div style="text-align:center">
                  clica
                  <v-icon v-if="true" small class="mr-2">edit</v-icon>para lancar nota de
                  <strong></strong> na turma:
                  <strong>{{this.$store.state.turma}}</strong> <br>
                <strong>Cadeira em Atraso</strong> </div>
                <div
                    v-if="$store.state.hasMessage"
                    :class="$store.state.classMessage"
                  >{{$store.state.textMessage}}</div>
                </v-header>
                <hr />

              </v-list>
            </v-card>
          </v-col>
        </v-row>

      </v-container>
      </v-form >
    </template>
  </div>
</template>

<script>
import axios from '../../plugins/axios'
import { get } from 'local-storage'
const ls = require('local-storage')
export default {
  data: () => ({
    formValid: true,
    on: false,
    notaRules: [
      // this.value.replace(/[^\d]/, ''),
      v => (v >= 0 && v <= 20) || 'nota invalida',
      v => !isNaN(v) || 'not number ',

      v => (v.length <= 2) || 'valor inválido'

    ],
    text: '',
    editedpk: false,
    disciplinas: [],
    disciplina: 0,
    _classe: '',
    idanoacademico: 0,
    progresso: true,
    offset: true,
    tumaSelect: '',
    iddisciplina: 0,
    idturma: 0,
    closeOnClick: true,
    item: 1,
    listaDeClassesPorLancarNotas: [],
    listEstudantfromPauta: [],
    listaEstudantesInscritos: [],
    editedIndex: -1,
    editedItem: {
      pkpauta: 0,
      p1_notaMac: 0,
      p1_nota: 0,
      p1_nota2: 0,
      p1_MD: 0,
      p2_notaMac: 0,
      p2_nota: 0,
      p2_nota2: 0,
      p2_MD: 0,
      p3_notaMac: 0,
      p3_nota: 0,
      p3_MD: 0,
      pg: 0,
      ca: 0,
      mfd: 0
    }
  }),
  computed: {

    idclasse () {
      return this.$store.state.idclasse
    }
  },

  watch: {

    listaDeClassesPorLancarNotas () {
      this.$store.state.isloading = false
    }
  },
  created () {
    this.turmaFindWithEstudanteCount('all')
    // this.CarregarDisciplinas();
    setTimeout(() => {
      this.progresso = false
    }, 10000)
  },

  methods: {
    classe (idanoacademico) {
      if (idanoacademico === 1) {
        this._classe = '10ª Classe'
      }
      if (idanoacademico === 2) {
        this._classe = '11ª Classe'
      }
      if (idanoacademico === 3) {
        this._classe = '12ª Classe'
      }
      if (idanoacademico === 4) {
        this._classe = '13ª Classe'
      }

      this.idanoacademico = idanoacademico
    },
    loadprogressbar () {
      this.$store.state.isloading = true
    },

    bt_edit (item) {
      this.editedIndex = this.listEstudantfromPauta.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedpk = item.pkpauta
      this.editedItem.trimestre = this.$store.state.idperfilpauta
      this.editedItem.pkpauta = item.pkpauta

      setTimeout(() => {}, 1000)
    },
    bt_save (editedItem) {
      // this.editedIndex = this.listEstudantfromPauta.indexOf(item)
      // this.editedItem = Object.assign({}, item)
      editedItem.p1_MD = Math.round(
        (Number(editedItem.p1_notaMac) +
          Number(editedItem.p1_nota) +
          Number(editedItem.p1_nota2)) /
          3
      )
      editedItem.p2_MD = Math.round(
        (Number(editedItem.p2_notaMac) +
          Number(editedItem.p2_nota) +
          Number(editedItem.p2_nota2)) /
          3
      )
      editedItem.p3_MD = Math.round(
        (Number(editedItem.p3_notaMac) +
          Number(editedItem.p3_nota)) /
          2
      )
      if (this.formValid) {
        this.save(editedItem)
        Object.assign(this.listEstudantfromPauta[this.editedIndex], editedItem)

        this.editedpk = 0
      }
      setTimeout(() => {}, 1000)
    },
    backTodisciplinList () {
      this.listEstudantfromPauta = []
    },
    backToTurmaList () {
      this.disciplinas = []
    },

    async turmaFindWithEstudanteCount (idclasse) {
      try {
        this.listaDeClassesPorLancarNotas = await axios
          .get('/ListarInscritosCadeira') // idclasse JyUn JQ==
          .then(res => res.data)
        console.log(this.listaDeClassesPorLancarNotas)
      } catch (error) {
        // this.isLoading = false

        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
      this.listEstudantfromPauta = []
    },
    async save (editedItem) {
      const ls = require('local-storage')
      var params = {
        p1_notaMac: editedItem.p1_notaMac,
        p1_nota: editedItem.p1_nota,
        p1_nota2: editedItem.p1_nota2,
        p1_MD: editedItem.p1_MD,
        p2_notaMac: editedItem.p2_notaMac,
        p2_nota: editedItem.p2_nota,
        p2_nota2: editedItem.p2_nota2,
        p2_MD: editedItem.p2_MD,
        p3_notaMac: editedItem.p3_notaMac,
        p3_nota: editedItem.p3_nota,
        p3_MD: editedItem.p3_MD,
        pg: editedItem.pg,
        ca: editedItem.ca,
        mfd: editedItem.mfd,
        autor: editedItem.autor,
        pkpauta: editedItem.pkpauta,
        trimestre: editedItem.trimestre
      }

      try {
        let msg = await axios.post('/lancarNota', params).then(res => res.data)
        // this.text = msg[1].insertId
        this.text = msg

        try {
          if (msg.affectedRows >= 1) {
            this.text = msg.affectedRows + ' gravado(s) com sucesso'
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgSucess',
              timeout: 2000
            })
          }
        } catch (error) {

        }
        try {
          this.text = msg.message.sqlMessage
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgError',
            timeout: 8000
          })
        } catch (error) {}
        try {
          this.text = msg.message.sqlMessage
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgError',
            timeout: 8000
          })
        } catch (error) {}

        if (this.editedIndex > -1) {
          //  Object.assign(this.estudantes[this.editedIndex], this.editedItem)
        } else {
          this.estudantes.push(this.editedItem)
          // console.log("this.editedItem: "+this.editedItem.nome)
        }
        //  this.close();
      } catch (error) {
        console.log('eroooo: ' + error)
        this.isLoading = false

        this.text = error.message
        this.$store.dispatch('textMessage', {
          msg: this.text + ' - ' + error,
          classMessage: 'msgError',
          timeout: 8000
        })
      } finally {
      }
    },

    // Carrega os dados dos que fizeram inscricao ========

    async ChamaListaInscritos (obj) {
      this.$store.state.objcadeira = obj
      this.$router.push('listarInscritos')
    }
  }
}
</script>
